import { Directive, Input } from "@angular/core";
import { UntypedFormControl, Validator, NG_ASYNC_VALIDATORS } from "@angular/forms";
import { get } from 'lodash';
import { ApiService } from "libs/common-lib/src/lib/providers/api/api.service";
import {catchError, map} from 'rxjs/operators';
import { EMPTY } from "rxjs";


@Directive({
  selector: "[claimCode][ngModel]",
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: ClaimCodeValidator,
      multi: true
    }
  ]
})
export class ClaimCodeValidator implements Validator {
  apiService: ApiService;
  useAbsolutePath: boolean;
  @Input("claimCode") configDef: any;

  constructor(
    apiService: ApiService
  ) {
    this.apiService = apiService;
  }

  validate(control: UntypedFormControl): Promise<any> {
    const claimCode = control.value;
    return new Promise(resolve => {
      this.claimCodeValidation(claimCode, resolve);
    });
  }

  claimCodeValidation(claimCode, resolve) {
    const config = get(this.configDef, `actions.hwLockCode`);
    const inputs: any = {};
    inputs.hwLockCode = claimCode;

    this.apiService.post$(config.url, inputs).pipe(
      map(result => {
        resolve(null);
      }),
      catchError( error => {
        let errorDetails = null;
        if (error.status === 406) {
          errorDetails = { claimnotfoundresult: "wrong" };
        } else if (error.status === 404) {
          errorDetails = { claimnotfoundresult: "wrong" };
        } else {
          errorDetails = { claimerror: "wrong" };
        }
        resolve(errorDetails);
        return EMPTY;
      })
    );
  }
}
